<template>
  <span v-line-clamp="1">
    <span
      class="
        background-color-fire-engine-red-trans
        color-fire-engine-red
        font-weight-semibold
        px-2
        py-1
        term-border-radius
      "
      :class="fontSize.term"
      >{{ term.offer }}</span
    >
    <span v-if="term.limit">{{ " " }}</span>
    <span class="color-suva-grey trans" :class="fontSize.max">{{
      term.limit
    }}</span>
  </span>
</template>
<script>
const fontSize = {
  small: { term: "font-size-xxs", max: "font-size-xxs" },
  large: { term: "font-size-sm", max: "font-size-xs" },
};

export default {
  name: "PromotionsTerm",
  computed: {
    fontSize() {
      return this.small ? fontSize.small : fontSize.large;
    },
  },
  props: { term: Object, small: Boolean },
};
</script>

<style scoped>
.term-border-radius {
  border-radius: 8px;
}

.trans {
  background-color: transparent;
}
</style>
